// hooks/api/PostHook.js
import { useState } from "react";
import { useSelector } from "react-redux";

function UsePostData(url) {
  const [isLoading, setIsLoading] = useState(false);
  const bearerToken = useSelector((state) => state?.auth?.userToken);
  const postData = async (data, formData) => {
    setIsLoading(true);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          ...(formData ? {} : { "Content-Type": "application/json" }),
          Authorization: `Bearer ${bearerToken}`,
        },
        body: formData ?? JSON.stringify(data),
      });

      const result = await response.json(); 
      if (!result.status === "success") {
        return result.message || "Failed to post data";
      }

      return result;
    } catch (error) {
      return error.message;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, postData };
}

export default UsePostData;
